import { Descendant, Text } from 'slate';

type CustomText = {
    text: string;
    bold?: boolean;
    italic?: boolean;
    underline?: boolean;
};

type CustomElement = {
    type: 'paragraph' | 'heading';
    children: (CustomElement | CustomText)[];
};

export const slateToHtml = (nodes: Descendant[]): string => {
    const result = nodes.map(node => {
        if (Text.isText(node)) {
            let text = node.text;
            if (node.bold) text = `<strong>${text}</strong>`;
            if (node.italic) text = `<em>${text}</em>`;
            if (node.underline) text = `<u>${text}</u>`;
            return text || '';;
        }

        const children = node.children ? slateToHtml(node.children) : '';
        switch (node.type) {
            case 'paragraph':
                return `<p>${children}</p>`;
            case 'heading':
                return `<h1>${children}</h1>`;
            default:
                return children;
        }
    }).join('');

    return result
};

export const htmlToSlate = (html: string): Descendant[] => {
    if (!/<p[^>]*>/i.test(html)) {
        html = `<p>${html}</p>`;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const body = doc.body;

    const traverseNode = (node: Node): Descendant[] => {
        if (node.nodeType === Node.TEXT_NODE) {
            return node.textContent ? [{ text: node.textContent }] : [];
        }

        const element = node as HTMLElement;
        let children: Descendant[] = [];

       for (const child of element.childNodes) {
            children = [...children, ...traverseNode(child)];
        }

        if (children.length === 0) {
            children = [{ text: '' }];
        }

        const applyStyles = (nodes: Descendant[], styles: Partial<CustomText>): Descendant[] => {
            return nodes.map(child => {
                if (Text.isText(child)) {
                    return { ...child, ...styles } as CustomText;
                } else {
                    return {
                        ...child,
                        children: applyStyles((child as CustomElement).children, styles)
                    } as CustomElement;
                }
            });
        };

        switch (element.nodeName) {
            case 'P':
                return [{ type: 'paragraph', children } as CustomElement];
            case 'H1':
                return [{ type: 'heading', children } as CustomElement];
            case 'B':
            case 'STRONG':
                return applyStyles(children, { bold: true });
            case 'I':
            case 'EM':
                return applyStyles(children, { italic: true });
            case 'U':
                return applyStyles(children, { underline: true });
            default:
                return children;
        }
    };

    const result = traverseNode(body);
    console.log('htmlToSlate result:', result);
    return result;
};

// Функция для проверки пустоты slate-поля
export const isSlateContentEmpty = (nodes: Descendant[]): boolean => {

    if (!nodes || nodes.length === 0) return true;

    return nodes.every(node => {
        if (Text.isText(node)) {
            return !node.text.trim();
        }

        if ('children' in node) {
            return isSlateContentEmpty(node.children);
        }

        return true;
    });
};

// Функция для удаления HTML-тегов
export const stripHtmlTags = (html: string): string => {
    if (!html) return '';
    return html.replace(/<[^>]+>/g, '');
};